import { useState } from "react";
import { Headset, Phone, MessageCircle, X } from "lucide-react";

const CARE = { name: "Sri Lakshmi Agencies", mobile: "9989436469" };

export default function CustomerCare() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-4 right-4 z-40 flex flex-col items-end gap-2 sm:bottom-6 sm:right-6">
      {open && (
        <div data-testid="customer-care-card" className="w-64 overflow-hidden rounded-2xl border border-indigo-100 bg-white shadow-[0_18px_40px_-12px_rgba(30,64,175,0.3)] animate-in fade-in slide-in-from-bottom-2 duration-200">
          <div className="flex items-start justify-between bg-gradient-to-r from-[#EEF4FB] to-[#F3F0FA] px-4 py-3">
            <div>
              <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-indigo-400">Customer Care</p>
              <p data-testid="customer-care-name" className="text-sm font-bold text-blue-900">{CARE.name}</p>
              <p data-testid="customer-care-mobile" className="text-sm font-semibold text-slate-600">+91 {CARE.mobile}</p>
            </div>
            <button data-testid="customer-care-close" onClick={() => setOpen(false)} aria-label="Close" className="rounded-md p-1 text-slate-400 hover:bg-white hover:text-slate-600">
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-2 p-3">
            <a data-testid="customer-care-call" href={`tel:+91${CARE.mobile}`} className="flex items-center justify-center gap-1.5 rounded-xl bg-blue-700 py-2.5 text-sm font-semibold text-white shadow-md shadow-blue-700/25 hover:bg-blue-800">
              <Phone className="h-4 w-4" /> Call
            </a>
            <a data-testid="customer-care-whatsapp" href={`https://wa.me/91${CARE.mobile}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-1.5 rounded-xl bg-emerald-600 py-2.5 text-sm font-semibold text-white shadow-md shadow-emerald-600/25 hover:bg-emerald-700">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>
        </div>
      )}
      <button
        data-testid="customer-care-button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-full border border-indigo-100 bg-white/95 py-2 pl-2 pr-4 text-sm font-semibold text-blue-900 shadow-lg shadow-blue-900/15 backdrop-blur transition-transform hover:-translate-y-0.5"
      >
        <span className="grid h-8 w-8 place-items-center rounded-full bg-gradient-to-br from-blue-600 to-indigo-500 text-white">
          <Headset className="h-4 w-4" />
        </span>
        Customer Care
      </button>
    </div>
  );
}
